export const PATIENT_AUTH_STORAGE_KEY = Object.freeze({
  questionnaireAccessToken: "existing_patient_access_token",
  questionnaireAccessExpiresAt: "existing_patient_expires",
  runtimeAccessToken: "existing_patient_runtime_access_token",
  runtimeAccessExpiresAt: "existing_patient_runtime_expires",
  sessionId: "existing_patient_session_id",
  patientInfo: "existing_patient_info",
  prefillData: "existing_patient_prefill",
});
